import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import ThreadListComponent from './ThreadListTemplateComponent';

import * as commonSelectors from '../../Shared/selectors';

const ThreadListContainer = (props) => {
  const {
    currentChatId,
    nextChatMessages,
    getChatById,
    isLoading,
    chatMessages,
    ...rest
  } = props;

  const loadChatMessages = async () => {
    const currentScroll = document.getElementById('messages_scroll_area')
      ?.parentNode?.scrollTop;
    await getChatById(currentChatId, nextChatMessages);
    document
      .getElementById('messages_scroll_area')
      ?.parentNode?.scroll(0, currentScroll);
  };

  return !chatMessages?.length && !isLoading ? null : (
    <ThreadListComponent
      chatMessages={
        nextChatMessages
          ? [...chatMessages, { id: `next${nextChatMessages?.offset}` }]
          : chatMessages
      }
      loadChatMessages={loadChatMessages}
      nextChatMessages={nextChatMessages}
      isLoading={isLoading}
      chatId={currentChatId}
      {...rest}
    />
  );
};

ThreadListContainer.defaultProps = {
  nextChatMessages: null,
  chatMessages: [],
};

ThreadListContainer.propTypes = {
  nextChatMessages: PropTypes.shape({
    limit: PropTypes.number,
    offset: PropTypes.number,
  }),
  getChatById: PropTypes.func.isRequired,
  chatMessages: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool.isRequired,
  currentChatId: PropTypes.number.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const isLoading = !!state?.common?.loading?.length;
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);
  return {
    isLoading,
    isMobileScreen,
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ThreadListContainer);
